<template>
    <div class="form-info">
        <el-form :model="devcInspectFlowInfo" :rules="devcInspectFlowRules" ref="devcInspectFlowInfo" class="demo-ruleForm">
            <div class="form-row">
                <div class="form-label" style="width: 155px;">
                    <label class="required">流程名称</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="name">
                        <el-input v-model="devcInspectFlowInfo.name" style="width:300px;" placeholder="请输入流程名称"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label" style="width: 155px;">
                    <label>是否需要送出</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="rented">
                        <el-radio-group v-model="devcInspectFlowInfo.objectSentOutFlag">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label" style="width: 155px;">
                    <label>妨碍正常生产</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="rented">
                        <el-radio-group v-model="devcInspectFlowInfo.interfereProdFlag">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>

            <div class="form-row" v-if="devcInspectFlowInfo.interfereProdFlag">
                <div class="form-label" style="width: 155px;">
                    <label class="required">妨碍正常生产开始动作</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="interfereStartAction">
                        <el-input v-model="devcInspectFlowInfo.interfereStartAction" style="width:300px;" placeholder="请输入妨碍正常生产开始动作"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-row" v-if="devcInspectFlowInfo.interfereProdFlag">
                <div class="form-label" style="width: 155px;">
                    <label class="required">恢复正常生产结束动作</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="interfereEndAction">
                        <el-input v-model="devcInspectFlowInfo.interfereEndAction" style="width:300px;" placeholder="请输入恢复正常生产结束动作"></el-input>
                    </el-form-item>
                </div>
            </div>

            <div class="form-row">
                <div class="form-label" style="width: 155px;">
                    <label>检验是否需要整改</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="rented">
                        <el-radio-group v-model="devcInspectFlowInfo.rectifyOnFailFlag">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>

            <div class="form-row" style="height: auto;overflow: hidden">
                <div class="form-label" style="width: 155px;">
                    <label>备注</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="desc">
                        <el-input type="textarea" placeholder="请描述备注" v-model="devcInspectFlowInfo.desc"></el-input>
                    </el-form-item>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import rentServcApi from '../../api/rentServc';

    export default {
        name: 'swb-devc-inspect-flow-save',
        path: '/devc/inspect/flow/save',
        props: ['id'],
        desc: '设备检验流程-新增',
        data: function () {
            let checkNull = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不可为空！'));
                } else {
                    callback();
                }
            };
            return {
                devcInspectFlowInfo: {
                    name: null,
                    objectSentOutFlag: false,
                    interfereProdFlag: false,
                    interfereStartAction: "停用/停止运行",
                    interfereEndAction: "启用/恢复运行",
                    rectifyOnFailFlag: false,
                },
                //
                devcInspectFlowRules: {
                    name: [{validator: checkNull, trigger: 'blur'}],
                    interfereStartAction: [{validator: checkNull, trigger: 'blur'}],
                    interfereEndAction: [{validator: checkNull, trigger: 'blur'}],
                },
            }
        },
        created: function () {
            let id = this.id;
            if(!Utils.isNoB(id)) {
                this.getDevcInspectFlowInfo(id);
            }
        },
        methods: {
            getDevcInspectFlowInfo: function (id) {
                let self = this;
                let postData = {
                    id: id
                };
                let theLoading = MsgBox.loading();
                rentServcApi.getDevcInspectFlowInfo(postData, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        let devcInspectFlowInfo = result.data || {};
                        //
                        let varDate = JSON.decode(devcInspectFlowInfo.vars);
                        devcInspectFlowInfo.objectSentOutFlag = varDate.objectSentOutFlag;
                        devcInspectFlowInfo.interfereProdFlag = varDate.interfereProdFlag;
                        devcInspectFlowInfo.interfereStartAction = varDate.interfereStartAction;
                        devcInspectFlowInfo.interfereEndAction = varDate.interfereEndAction;
                        devcInspectFlowInfo.rectifyOnFailFlag = varDate.rectifyOnFailFlag;
                        //
                        self.devcInspectFlowInfo = devcInspectFlowInfo;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 生成[参数变量]json
            makeVarsJsonDate: function (devcInspectFlowInfo) {
                let jsonDate = {
                    objectSentOutFlag: devcInspectFlowInfo.objectSentOutFlag,
                    interfereProdFlag: devcInspectFlowInfo.interfereProdFlag,
                    interfereStartAction: devcInspectFlowInfo.interfereStartAction,
                    interfereEndAction: devcInspectFlowInfo.interfereEndAction,
                    rectifyOnFailFlag: devcInspectFlowInfo.rectifyOnFailFlag,
                };
                return JSON.encode(jsonDate);
            },
            //
            getDlgResult(){
                let self = this;
                let result = {};
                result.type = "warn";
                //
                this.$refs['devcInspectFlowInfo'].validate(function (valid) {
                    if(valid) {
                        let devcInspectFlowInfo = self.devcInspectFlowInfo || {};
                        devcInspectFlowInfo.vars = self.makeVarsJsonDate(devcInspectFlowInfo);
                        //
                        result.type = "info";
                        result.data = devcInspectFlowInfo;
                    } else {
                        result.message = "请输入必填项！";
                    }
                });
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/rentServc/DevcInspectFlowSave.vue